import styles from "../shPaymentProductModal.module.scss";

const ShCheckoutHeaderWrapper = ( { children } ) => {
    return <ul className={styles.progressBar + " w-100 justify-content-between d-flex pr-auto pr-1 pr-md-2"}>
        { children }
    </ul>
};

export default ShCheckoutHeaderWrapper;
